var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 30.854,
    viewBox: "0 0 38 30.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(-3242.187 -7155.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M3242.187,7183.447v-24.86a.5.5,0,0,0,.05-.1,3.505,3.505,0,0,1,3.717-2.934q15.247,0,30.494,0a3.507,3.507,0,0,1,3.733,3.7q0,7.79,0,15.58v.354l-.127.089a2.64,2.64,0,0,0-.271-.388q-3.43-3.442-6.871-6.875a1.185,1.185,0,0,0-1.993,0q-4.117,4.119-8.237,8.237c-.094.094-.192.184-.3.29-.11-.1-.21-.194-.3-.289q-1.746-1.742-3.49-3.488a1.184,1.184,0,0,0-1.967.01q-6.322,6.323-12.642,12.646a4.1,4.1,0,0,0-.321.431,9.556,9.556,0,0,1-.934-1.124A8.945,8.945,0,0,1,3242.187,7183.447Zm9.428-13.735a4.691,4.691,0,1,0-4.663-4.733A4.72,4.72,0,0,0,3251.615,7169.712Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M3246.214,7186.406h.291q15.044,0,30.086,0a3.491,3.491,0,0,0,3.59-3.624c0-1.336,0-2.671.006-4.007a.739.739,0,0,0-.243-.58q-3.89-3.875-7.768-7.76c-.084-.084-.174-.162-.3-.281-.1.125-.181.238-.276.334q-4.156,4.161-8.315,8.317a1.134,1.134,0,0,1-1.81,0q-1.786-1.782-3.569-3.567c-.093-.093-.191-.183-.266-.254Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M3246.214,7186.406l11.423-11.426c.075.071.173.161.266.254q1.785,1.783,3.569,3.567a1.134,1.134,0,0,0,1.81,0q4.159-4.156,8.315-8.317c.095-.1.174-.209.276-.334.129.119.219.2.3.281q3.883,3.88,7.768,7.76a.739.739,0,0,1,.243.58c-.011,1.336,0,2.671-.006,4.007a3.491,3.491,0,0,1-3.59,3.624q-15.044.011-30.086,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M3251.7,7162.559a2.463,2.463,0,1,1-2.516,2.391A2.475,2.475,0,0,1,3251.7,7162.559Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.7d685045.svg";
export { ForwardRef as ReactComponent };